import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HomeService } from 'src/home/home.service';
import { Fee } from 'src/models/Fee.interface';
import Swal from 'sweetalert2';
import { CrmService } from '../services/crm.service';

@Component({
  selector: 'app-crm-create-fee',
  templateUrl: './crm-create-fee.component.html',
  styleUrls: ['./crm-create-fee.component.css']
})
export class CrmCreateFeeComponent {

  feesForm: FormGroup;
  isLoading: boolean = false;

  constructor(private homeService: HomeService, private fb: FormBuilder, private crmService: CrmService) {

    this.feesForm = this.fb.group({
      cif: ['', Validators.required],
      delegation: ['', Validators.required],
      clientCode: ['', Validators.required],
      conceptId: ['', Validators.required],
      description: ['', Validators.required],
      familyId: ['', Validators.required],
      family: ['', Validators.required],
      amount: ['', Validators.required],
      discount: ['', Validators.required],
      payMethod: ['', Validators.required],
      payDay: ['', Validators.required]
    });
  }

  handleCreateFee(): void {
    if (this.feesForm.valid) {
      const newFee: Fee = {
        cif: this.feesForm.get('cif')?.value,
        delegation: this.feesForm.get('delegation')?.value,
        clientCode: parseInt(this.feesForm.get('clientCode')?.value),
        conceptId: parseInt(this.feesForm.get('conceptId')?.value),
        description: this.feesForm.get('description')?.value,
        familyId: parseInt(this.feesForm.get('familyId')?.value),
        family: this.feesForm.get('family')?.value,
        amount: parseInt(this.feesForm.get('amount')?.value),
        discount: parseInt(this.feesForm.get('discount')?.value),
        payMethod: parseInt(this.feesForm.get('payMethod')?.value),
        payDay: parseInt(this.feesForm.get('payDay')?.value)
      };
      if (newFee) {
        this.isLoading = true;
        this.crmService.createFee(newFee).subscribe(
          () => {
            this.isLoading = false;
            Swal.fire({
              text: 'Tarifa creada exitosamente',
              icon: 'success',
              confirmButtonText: 'OK',
              confirmButtonColor: '#4caf50'
            });
            this.feesForm.reset();
          },
          (error) => {
            this.isLoading = false;
            Swal.fire({
              text: 'Error al crear la tarifa. Por favor, inténtalo de nuevo.',
              icon: 'error',
              confirmButtonText: 'OK',
              confirmButtonColor: '#d33'
            });
          }
        );
        this.feesForm.reset();
      }
    }
  }
}
